import React from 'react';
import LotDensidadPoblacionalSection from './LotDensidadPoblacionalSection';
import LotNeighborhoodTypeSection from './LotNeighborhoodTypeSection';
import LotRoadFrontTypeSection from './LotRoadFrontTypeSection';
import LotStreetPositionSection from './LotStreetPositionSection';
import LotDetailSectionShell, { LotDetailTable, LotDetailTableRow } from './LotDetailSectionShell';

/**
 * Características urbanísticas del lote (calle, posición en manzana, tipología, superficie, densidad).
 */
const LotEntornoUrbanoSection = ({
  frontHighwayType = null,
  streetPosition = null,
  neighborhoodType = null,
  urbanSurface = null,
  populationDensity = null,
  blocked = false,
  blockedMessage = 'Iniciá sesión para ver el entorno urbano del lote.',
  hideTitle = false,
}) => (
  <LotDetailSectionShell
    title="Entorno urbano"
    hideTitle={hideTitle}
    blocked={blocked}
    blockedMessage={blockedMessage}
  >
    <LotDetailTable>
      <LotDetailTableRow>
        <LotRoadFrontTypeSection frontHighwayType={frontHighwayType} />
      </LotDetailTableRow>
      <LotDetailTableRow>
        <LotStreetPositionSection streetPosition={streetPosition} />
      </LotDetailTableRow>
      <LotDetailTableRow>
        <LotNeighborhoodTypeSection neighborhoodType={neighborhoodType} />
      </LotDetailTableRow>
      <LotDetailTableRow hideDivider>
        <LotDensidadPoblacionalSection populationDensity={populationDensity} />
      </LotDetailTableRow>
    </LotDetailTable>
  </LotDetailSectionShell>
);

export default LotEntornoUrbanoSection;
